import GetArticleResponse from '../CRM/Responses/ArticleResponse';

import Model from './Model';
import SeoTag from './SeoTag';

export default class Article extends Model {
    readonly id: number;
    readonly language_id: number;
    readonly translation_id: number;
    readonly lottery_id: number | null;
    readonly system_page_type: string | null;
    readonly system_page_position: string | null;
    readonly title: string;
    readonly is_title_hidden: boolean | null = false;
    readonly slug: string;
    readonly mobile_slug: string | null;
    readonly text: string | null;
    readonly no_deletable: boolean;
    readonly no_index: boolean;
    readonly is_partial: boolean;
    readonly is_blog: boolean | null;
    readonly is_casino_page: boolean;
    readonly comment: string | null;
    readonly publication_date: string | null;
    readonly created_at: string | null;
    readonly updated_at: string | null;
    readonly timezone: string | null;

    readonly seo_tag: SeoTag | null;
    readonly system_page_seo_tag: SeoTag | null;

    constructor(menu: Partial<GetArticleResponse>) {
        super();
        this.assignDataToProps(menu, [
            'id',
            'language_id',
            'translation_id',
            'lottery_id',
            'system_page_type',
            'system_page_position',
            'title',
            'is_title_hidden',
            'slug',
            'mobile_slug',
            'text',
            'no_deletable',
            'no_index',
            'is_partial',
            'is_blog',
            'is_casino_page',
            'comment',
            'publication_date',
            'created_at',
            'updated_at',
            'seo_tag',
            'system_page_seo_tag',
            'timezone',
        ]);
    }
}
